import { ReactNode } from "react";
import { usePlan } from "@/features/auth/hooks/usePlan";
import { AccessDeniedPage } from "@/features/auth/pages/AccessDeniedPage";
import type { PlanFeatures } from "@/features/auth/types/plan.type";

type PlanRouteGuardProps = {
  children: ReactNode
  requiredFeature: keyof PlanFeatures | (keyof PlanFeatures)[]
  fallback?: ReactNode
};

export const PlanRouteGuard = ({ children, requiredFeature, fallback }: PlanRouteGuardProps) => {
  const plan = usePlan();

  const features = Array.isArray(requiredFeature) ? requiredFeature : [requiredFeature];
  const hasAccess = !!plan && features.some((feature) => plan.features[feature]);

  if (!hasAccess) {
    return fallback ?? <AccessDeniedPage />;
  }

  return <>{children}</>;
};
